var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlomoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 22,
    viewBox: "0 0 115 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3141 16.9922V0.00624401H25.3974V21.9336L38.611 21.9336V16.9922H30.3141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7732 21.9336C58.6707 21.9336 62.6206 17.0632 62.6206 11.0554C62.6206 4.6765 58.4054 0.00625814 51.6847 0.00625814C44.9641 0.00625814 40.631 4.73345 40.8079 11.0554C40.9848 17.3773 44.5514 21.9336 51.7732 21.9336ZM51.7358 18.3057C55.1886 18.3057 57.9876 15.0234 57.9876 10.9746C57.9876 6.92575 55.1886 3.64351 51.7358 3.64351C48.2831 3.64351 45.4841 6.92575 45.4841 10.9746C45.4841 15.0234 48.2831 18.3057 51.7358 18.3057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.153 21.9336C111.05 21.9336 115 17.0632 115 11.0554C115 4.6765 110.785 0.00625814 104.064 0.00625814C97.3435 0.00625814 93.0105 4.73345 93.1873 11.0554C93.3642 17.3773 96.9309 21.9336 104.153 21.9336ZM104.059 18.3455C107.494 18.3455 110.279 15.0561 110.279 10.9984C110.279 6.94072 107.494 3.65132 104.059 3.65132C100.624 3.65132 97.8394 6.94072 97.8394 10.9984C97.8394 15.0561 100.624 18.3455 104.059 18.3455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9083 0.00625814L78.0284 13.7896L71.8944 0.0370952L66.3778 0.037095V21.9336H71.8944V12.7948L76.4417 21.9336H80.1292L83.9083 13.7781V21.9336H89.4249V0.00625814H83.9083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6932 21.8475C12.1899 21.9037 11.6684 21.9326 11.1292 21.9326C9.84298 21.9326 8.67107 21.7922 7.61198 21.5263C5.67009 20.9138 3.85634 19.784 2.5301 18.3068C2.0639 17.7876 1.71039 17.266 1.4688 16.7753C1.02137 16.0444 0.709243 15.2508 0.491839 14.4842C0.200991 13.4184 0.0392692 12.2675 0.00475995 11.0513C0.00234886 10.9663 0.000763934 10.8816 0 10.7972C0.00119701 10.6871 0.00399203 10.6272 0.00399203 10.6272C0.00399203 10.6272 0.00399203 8.96559 0.492182 7.47012C0.557474 7.1146 0.670117 6.72056 0.831997 6.30466C2.38028 2.54706 5.99331 0.0565869 10.8694 0C15.8859 0.0550209 18.6081 2.40182 19.3476 3.63548L16.6218 6.40353C15.6419 5.35661 14.668 4.70398 13.7484 4.30991C12.9402 3.87817 12.0401 3.63731 11.0913 3.63731C9.09045 3.63731 7.30601 4.7085 6.14356 6.38194C5.41155 7.35157 4.86253 8.56431 4.72377 9.96257C4.47115 12.5082 4.80856 13.177 5.48655 14.5208C5.55446 14.6554 5.62579 14.7968 5.70029 14.9475C5.78866 15.0806 5.89398 15.2216 6.01488 15.3674C7.17189 17.1502 9.01509 18.3037 11.0913 18.3037C12.804 18.3037 14.3582 17.8921 15.4994 16.6164V20.7704C14.6507 21.3837 13.6974 21.6322 12.6932 21.8475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1142 9.30516H21.9706V22H18.2973V13.0112H9.1142V9.30516Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlomoLogo);
export default __webpack_public_path__ + "static/media/glomo_logo.92808c6af9d450539bb3d5d68366dea6.svg";
export { ForwardRef as ReactComponent };